import { __read } from "tslib";
import React, { useState, useEffect } from 'react';
import './Badge.css';
export var Badge = function (_a) {
    var children = _a.children, fetchMail = _a.fetchMail, tld = _a.tld, hideCounter = _a.hideCounter;
    var _b = __read(useState(0), 2), unread = _b[0], setUnread = _b[1];
    useEffect(function () {
        if (!fetchMail || hideCounter)
            return;
        fetch("https://mail.yandex." + tld + "/api/v2/serp/counters?silent", { credentials: 'include' })
            .then(function (res) { return res.json(); })
            .then(function (data) { return setUnread(data.counters.unread); })
            .catch(function (_) {
            /**
             * Почта на большом потоке данных может иногда падать по таймауту,
             * Поэтому ошибку пропускаем, считаем, что она не критичная и не логирируем её,
             * чтобы не сыпать алерты на сервисах.
             */
        });
    }, [tld, fetchMail, hideCounter]);
    var mailCounter = fetchMail && unread > 0 ? Math.min(unread, 99) : undefined;
    var showPlus = Boolean(fetchMail && mailCounter && unread > mailCounter);
    var content = mailCounter && !hideCounter ? "" + mailCounter + (showPlus ? '+' : '') : null;
    return (React.createElement("div", { className: "UserID-Badge" },
        children,
        React.createElement("div", { className: "UserID-Badge-Dot" }, content)));
};
Badge.displayName = 'UserIDBadge';
